module.exports = __webpack_public_path__ + "assets/img/jody-mic.fb5ae85c.png";